import {DomainSequenceType} from 'antibodies/domain-annotation/DomainAnnotationTypes';
import promptAndAnnotateDomainSequences from 'antibodies/domain-annotation/promptAndAnnotateDomainSequences';
import {ListableItem} from 'search/SearchConstants';
import * as ShortcutUtil from 'util/ShortcutUtil';

/**
 * Prompts for annotation settings and starts annotating the selected listing items. The items must already
 * pass `getDomainAnnotationDisabledReason`.
 */
export default async function annotateListingDomainSequences({
  items,
  sequenceType,
}: {
  items: Array<ListableItem>;
  sequenceType: DomainSequenceType;
}): Promise<void> {
  await promptAndAnnotateDomainSequences({
    sequenceIds: items.map((item) => item.id),
    sequenceType,
    initialFolderId: ShortcutUtil.findCommonProjectFolderId(items, []),
  });
}
